import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function resetExportTimelineState(): RootActionTypes {
  return {
    type: ActionTypes.EXPORT_TIMELINE_RESET_STATE,
  };
}
